// extracted by mini-css-extract-plugin
export default {"sider":"index-module__hCq7r"};